import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '@services/api.service';

type NestJSHttpException = {
  success: boolean;
  errors: [
    {
      id: string;
      message: string;
    },
  ];
  name: string;
  message: string;
  path: string;
};

@Component({
  selector: 'ew-validation-code',
  templateUrl: './validation-code.component.html',
  styleUrls: ['./validation-code.component.scss'],
})
export class ValidationCodeComponent implements AfterViewInit {
  @Input() class!: string;
  @Input() hasSubmitted: boolean = false;
  @Input() type: 'PAYOUT' | 'WITHDRAWAL' | undefined = undefined;
  @Input() action: 'PAYOUT' = 'PAYOUT';
  @Output() validated: EventEmitter<string> = new EventEmitter();
  form: FormGroup;
  failedToSubmit: boolean = false;
  errorMessage?: string;

  constructor(
    private FB: FormBuilder,
    private API: ApiService,
    private translate: TranslateService,
  ) {
    this.form = this.FB.group({
      one: ['', Validators.required],
      two: ['', Validators.required],
      three: ['', Validators.required],
      four: ['', Validators.required],
      five: ['', Validators.required],
      six: ['', Validators.required],
    });
  }

  ngAfterViewInit(): void {
    this.sendCode();
  }

  /**
   * change input automatic
   * @author Martin Batun Tec.
   */
  move(e: any, p: any, c: any, n: any): void {
    var length = c.value.length;
    var maxLength = c.getAttribute('maxLength');

    if ((length == maxLength && n) || (e.key == 'ArrowRight' && n)) {
      n.focus();
    } else if (
      (p && !length && e.key == 'Backspace') ||
      (p && e.key == 'ArrowLeft')
    ) {
      p.focus();
    }
  }

  /**
   * set the code in the form
   * @param event input event after paste event
   * @author Martin Batun Tec.
   */
  paste(event: ClipboardEvent): void {
    let clipboardData: any = event.clipboardData;
    let pasted = clipboardData.getData('text').split('');
    this.form.patchValue({
      one: pasted[0],
      two: pasted[1],
      three: pasted[2],
      four: pasted[3],
      five: pasted[4],
      six: pasted[5],
    });
  }

  /**
   * send the code to email
   * @author Martin Batun Tec.
   */
  sendCode(): void {
    this.failedToSubmit = false;
    this.errorMessage = undefined;

    this.API.post('two-factor-auth/', { action: this.action }).subscribe({
      next: (data) => {},
      error: ({ error }: { error: NestJSHttpException }) => {
        this.failedToSubmit = true;
        this.errorMessage = this.translate.instant(error.message);
      },
    });
  }

  /**
   * send the code to validate
   * @author Martin Batun Tec.
   */
  validate(): void {
    let value = this.form.value;
    this.validated.next(
      value.one + value.two + value.three + value.four + value.five + value.six,
    );
  }
}
